import { render, staticRenderFns } from "./GetFilesAudio.vue?vue&type=template&id=772767ac&"
import script from "./GetFilesAudio.vue?vue&type=script&lang=js&"
export * from "./GetFilesAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports